import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20coral%20and%20cream%20tones%2C%20gentle%20flowing%20shapes%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20design%2C%20korean%20comics%20reading%20platform%20branding%20style&width=1600&height=800&seq=cta-home-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/55"></div>

      <div className="relative z-10 max-w-[800px] mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          立即开始你的韩漫之旅
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-lg mx-auto leading-relaxed">
          超过 12,000 部韩国漫画等你来发现，每日更新，免费阅读
        </p>
        <Link
          to="/category/fantasy"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          免费阅读
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>
    </section>
  );
}